import * as React from 'react';
import styled, { useTheme } from 'styled-components';
import { Anchor, Br, Flex, Text } from '../../../components/blocks';

import Security from '../../../images/banner/icon-security.svg';

const Root = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin: 0 auto;
  gap: ${({ theme }) => theme.spaces.xxl};
  padding: ${({ theme }) => theme.spaces.xxl};
  background: ${({ theme }) => theme.backgroundColors.primary};
  border-radius: ${({ theme }) => theme.radii.m};

  ${({ theme }) =>
    theme.screen.sp({
      flexDirection: 'column',
      gap: theme.spaces.l,
    })}
`;

const SP = styled.span`
  ${({ theme }) =>
    theme.screen.sp({
      fontSize: theme.fontSizes.s,
      display: 'block',
    })}
`;

export const SecurityBanner: React.FC = () => {
  const theme = useTheme();

  return (
    <Root>
      <Flex flexShrink="0">
        <Security width="80px" height="80px" alt="セキュリティアイコン" />
      </Flex>
      <Flex flexDirection="column" alignItems="flex-start" gap={theme.spaces.l}>
        <Text as="h2" size="xxl" fontWeight="bold" color="white" lineHeight="m">
          セキュリティ万全のクラウドツールだから、
          <Br />
          いつでもどこでも安心して使える
        </Text>
        <Text
          size="s"
          color="white"
          fontWeight="bold"
          lineHeight="l"
          textAlign="justify"
        >
          安心して業務が行えるよう、セキュリティ強化に取り組んでおります。
          <Br />
          Dentisは国際標準規格に適合した「ISMS」の認証を受けており、暗号化による通信の保護や二要素認証によるセキュリティ強化のほか、クライアント認証を発行することで、アクセスできるデバイスを制限することも可能です。
          <Br />
        </Text>
        <Anchor
          color="secondary"
          size="s"
          to="/security"
          radius="rounded"
          wide="l"
        >
          <Text whiteSpace="normal" color="primary" fontWeight="bold">
            Dentisのセキュリティの取り組みについて
          </Text>
        </Anchor>
      </Flex>
    </Root>
  );
};
